'use client'

import dynamic from 'next/dynamic'

const CartModal = dynamic(
  () => import('./CartModal').then((m) => ({ default: m.CartModal })),
  {
    ssr: false,
    loading: () => null,
  },
)

export { type CartItem } from './types'

export function Cart() {
  return (
    <>
      <CartModal />
    </>
  )
}
